import { createSlice } from "@reduxjs/toolkit";
import { RootState } from "setup/redux/RootReducer";

type InitialState = {
  ShowSessionExpired: boolean;
};

const initialState: InitialState = {
  ShowSessionExpired: false,
};

export const sessionExpiredSlice = createSlice({
  name: "sessionExpired",
  initialState,
  reducers: {
    setShowSessionExpired: (state, action) => {
      state.ShowSessionExpired = action.payload;
    },
  },
});

export const { setShowSessionExpired } = sessionExpiredSlice.actions;
export const selectSessionExpired = (state: RootState) => state.sessionExpired.ShowSessionExpired;

export default sessionExpiredSlice.reducer;
